import React, { FC, useEffect, useState } from 'react'
import s from './Header.module.scss'
import { Link, NavLink } from 'react-router-dom'
import { ReactComponent as Logo } from './../../assets/icons/logoHeader.svg';
import { ReactComponent as MaxIcon } from './../../assets/icons/maxIcon.svg';
import { FaPhone, FaEnvelope, FaTelegram, FaWhatsapp } from 'react-icons/fa';
import Dropdown from '../Dropdown/Dropdown';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import BurgerMenu from '../BurgerMenu/BurgerMenu';
import { FaChevronRight } from 'react-icons/fa6'
import { fetchByServices } from '../../store/slices/servicesSlice';


const Header: FC = () => {
    const { info } = useAppSelector(state => state.info)
    const { data } = useAppSelector(state => state.services)
    const [isBurgerOpen, setIsBurgerOpen] = useState(false);

    const dispatch = useAppDispatch()
    useEffect(() => {
        dispatch(fetchByServices())
    }, [dispatch])


    const toggleBurger = () => {
        setIsBurgerOpen(!isBurgerOpen);
    };

    return (
        <header className={s.header}>
            <BurgerMenu isOpen={isBurgerOpen} onToggle={toggleBurger} />
            
            <nav className={`${s.nav} container`}>
                <Link to={'/'} className={s.logo} onClick={() => setIsBurgerOpen(false)}>
                    <Logo />
                </Link>
                
                <ul className={s.menu}>
                    <li><NavLink className={({ isActive }) => isActive ? s.active : ''} to={'/'} >Главная</NavLink></li>
                    <Dropdown title={'Услуги'}>
                        {data?.map((el) => (
                            <NavLink key={el.id} className={({ isActive }) => `${s.dropdown_link} ${isActive ? s.dropdown_active : ''}`} to={`/services/${el.id}/${el.name_card}`}>{el.name_card} <span>{React.createElement(FaChevronRight as any)}</span></NavLink>
                        ))}
                    </Dropdown>
                    <li><NavLink className={({ isActive }) => isActive ? s.active : ''} to={'/projects'} >Проекты</NavLink></li>
                    <li><NavLink className={({ isActive }) => isActive ? s.active : ''} to={'/products'} >Продукция</NavLink></li>
                    <li><NavLink className={({ isActive }) => isActive ? s.active : ''} to={'/about-us'} >О нас</NavLink></li>
                    <li><NavLink className={({ isActive }) => isActive ? s.active : ''} to={'/contacts'} >Контакты</NavLink></li>
                    {/* <li><NavLink className={({ isActive }) => isActive ? s.active : ''} to={'/articles'} >Статьи</NavLink></li> */}
                </ul>
                
                <ul className={s.contacts}>
                    <div>
                        <li><a rel="noreferrer noopener" href={`tel:${info?.contacts?.phone}`}>{React.createElement(FaPhone as any)}{info?.contacts?.phone}</a></li>
                        <li><a rel="noreferrer noopener" href={`mailto:${info?.contacts?.email}`}>{React.createElement(FaEnvelope as any)}{info?.contacts?.email}</a></li>
                    </div>
                    <div>
                        <li><a target='_blank' rel="noreferrer noopener" href={`${info?.contacts?.telegram}`}>{React.createElement(FaTelegram as any)}</a></li>
                        <li><a target='_blank' rel="noreferrer noopener" href={`${info?.contacts?.whatsapp}`}>{React.createElement(FaWhatsapp as any)}</a></li>
                        {info?.contacts?.vk && (
                            <li>
                                <a target='_blank' rel="noreferrer noopener" href={`${info?.contacts?.vk}`}>
                                    {React.createElement(MaxIcon as any)}
                                </a>
                            </li>
                        )}
                    </div>
                </ul>
                
                <button onClick={toggleBurger} className={s.burgerButton} aria-label="Toggle menu">
                    <svg 
                        className={`${s.burger} ${s.ham} ${s.hamRotate} ${isBurgerOpen ? s.isOpen : ''}`} 
                        viewBox="0 0 100 100"
                        width="60"
                        height="60"
                    >
                        <path
                            className={`${s.line} ${s.top}`}
                            d="m 30,33 h 40 c 0,0 9.044436,-0.654587 9.044436,-8.508902 0,-7.854315 -8.024349,-11.958003 -14.89975,-10.85914 -6.875401,1.098863 -13.637059,4.171617 -13.637059,16.368042 v 40"
                        />
                        <path className={`${s.line} ${s.middle}`} d="m 30,50 h 40" />
                        <path
                            className={`${s.line} ${s.bottom}`}
                            d="m 30,67 h 40 c 12.796276,0 15.357889,-11.717785 15.357889,-26.851538 0,-15.133752 -4.786586,-27.274118 -16.667516,-27.274118 -11.88093,0 -18.499247,6.994427 -18.435284,17.125656 l 0.252538,40"
                        />
                    </svg>
                </button>
            </nav>
        </header>
    )
}

export default Header